import {Component, OnInit} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {isIE} from '@util/browser';
import {AuthService} from '@common/messe-ui-toolkit';
import {environment} from '@environments/environment';
import {RouteBuilder} from '@util/route-builder';
import {MarkantElementsModule} from '@markant/elements-angular';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink, MarkantElementsModule],
})
export class ToolbarComponent implements OnInit {
  isIE = isIE;
  private loggedIn: boolean;

  constructor(
    private readonly authService: AuthService,
    public readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.loggedIn = false;
    this.authService.isLoggedIn().subscribe((isLoggedIn) => (this.loggedIn = isLoggedIn));
  }

  logout() {
    this.authService.logout();
  }

  isLoggedIn(): boolean {
    return this.loggedIn;
  }

  environmentIsNotProd(): boolean {
    return !environment.production;
  }

  buildBackLink(): string {
    if (environment.production) {
      return 'https://voila-startups.com';
    }
    return '';
  }

  get signupRoute(): string {
    return RouteBuilder.signup().build();
  }

  get loginRoute(): string {
    return RouteBuilder.login().build();
  }
}
